import { validateEmail } from 'utils/helpers';
import isConsentGranted from 'utils/consent-check';
import { trackEvent } from 'utils/tracking';

const SimonDataSignUp = async (analyticsEvent, consentRequired) => {
  const emailFormWrapper = document.querySelector('[data-newsletter-form]');
  const emailForm = emailFormWrapper.querySelector('form');
  const emailInputWrapper = emailFormWrapper.querySelector('domaine-input[data-input]');
  const emailFormInput = emailFormWrapper.querySelector('input[type="email"]');
  const checkBoxInputWrapper = emailFormWrapper.querySelector('domaine-input[data-checkbox]');
  const checkBoxInput = emailFormWrapper.querySelector('input[type=checkbox]');
  emailInputWrapper.removeAttribute('error');
  checkBoxInputWrapper.removeAttribute('error');

  try {
    if (
      emailFormInput.value.trim().length === 0 ||
      validateEmail(emailFormInput.value) === false ||
      !isConsentGranted(consentRequired) ||
      (checkBoxInput && !checkBoxInput.checked)
    ) {
      if (!isConsentGranted(consentRequired)) {
        emailInputWrapper.errorText = window.TMW.Strings.general.forms.submitError.consent;
        throw new Error(window.TMW.Strings.general.forms.submitError.consent);
      }
      if (checkBoxInput && !checkBoxInput.checked) {
        emailInputWrapper.errorText = window.TMW.Strings.general.forms.submitError.optInRequired;
        checkBoxInputWrapper.setAttribute('error', '');
        throw new Error(window.TMW.Strings.general.forms.submitError.optInRequired);
      }
      emailInputWrapper.errorText = window.TMW.Strings.general.forms.submitError.email;
      throw new Error(window.TMW.Strings.general.forms.submitError.email);
    }

    const today = new Date();

    // eslint-disable-next-line no-undef
    sd.identify('', {
      email: emailFormInput.value,
    });

    // eslint-disable-next-line no-undef
    sd.track('registration', {
      email: emailFormInput.value,
      optIn: true,
      properties: {
        account: 'email',
        thinx_marketing: 'true',
        signup: 'thinx_footer',
        dateaddedthinx: today.toLocaleDateString(),
        source: 'thinx_footer',
      },
    });

    trackEvent({
      event: 'registration',
      brand: 'THINX',
      email: emailFormInput.value,
      opt_in: true,
      source: 'thinx_footer',
    });

    emailFormWrapper.setAttribute('success', '');

    if (analyticsEvent) {
      const formData = new FormData(emailForm);
      const data = Object.fromEntries(formData);
      Shopify.analytics.publish(analyticsEvent, data);
    }

    emailFormInput.value = '';
    setTimeout(() => {
      emailFormWrapper.removeAttribute('success');
    }, 3000);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Error submitting form', error);
    emailInputWrapper.setAttribute('error', '');
  }
};

export default SimonDataSignUp;
